import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import LoadingSpinner from "../components/LoadingSpinner";

function Planograms() {
    const navigate = useNavigate();
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        api.stores()
            .then((data) => {
                setStores(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    if (loading) return <LoadingSpinner message="Loading planograms..." />;

    // Only show stores that have scans (i.e. cameras active)
    const activeStores = stores.filter(
        (s) => s.lastScanAt || s.openIssues > 0
    );
    const filteredStores = activeStores.filter(
        (s) =>
            s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            s.siteId.includes(searchTerm)
    );

    const zones = [
        { code: "GD", label: "Gondola Aisle", category: "GONDOLA_AUDIT" },
        { code: "PF", label: "Pie Face Cabinet", category: "PIE_CABINET" },
        { code: "AW", label: "Auto Wall", category: "AUTO_WALL" },
        { code: "FD", label: "Freezer Doors", category: "FREEZER_DOORS" },
        { code: "CD", label: "Coolroom Doors", category: "COOLROOM_DOORS" },
        { code: "PS", label: "POS Counter", category: "POS_COUNTER" },
    ];

    return (
        <div>
            <div className="page-header">
                <h2>Planograms</h2>
                <p>Zone compliance reference by store</p>
            </div>

            <div style={{ marginBottom: 20 }}>
                <input
                    type="text"
                    className="filter-input"
                    placeholder="Search by store name or site ID..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                        background: "var(--bg-card)",
                        border: "1px solid var(--border)",
                        borderRadius: 8,
                        padding: "10px 14px",
                        color: "var(--text-primary)",
                        fontSize: 14,
                        width: 300,
                    }}
                />
            </div>

            {filteredStores.length === 0 ? (
                <div className="card" style={{ padding: 40, textAlign: "center" }}>
                    <p style={{ color: "var(--text-muted)", fontSize: 16 }}>
                        {activeStores.length === 0
                            ? "No active stores with scan data yet"
                            : "No stores match your search"}
                    </p>
                </div>
            ) : (
                filteredStores.map((store) => (
                    <div className="card" key={store.siteId} style={{ marginBottom: 16 }}>
                        <div
                            className="card-title"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                            }}
                            onClick={() => navigate(`/store/${store.siteId}`)}
                        >
                            <span>
                                {store.name}{" "}
                                <span style={{ color: "var(--text-muted)", fontWeight: 400, fontSize: 13 }}>
                                    #{store.siteId}
                                </span>
                            </span>
                            <span style={{ fontSize: 13, color: "var(--text-secondary)" }}>
                                {store.openIssues} open issues â†’
                            </span>
                        </div>
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                                gap: 12,
                                marginTop: 12,
                            }}
                        >
                            {zones.map((zone) => (
                                <div
                                    key={zone.code}
                                    style={{
                                        background: "var(--bg-main)",
                                        borderRadius: 8,
                                        padding: 14,
                                        border: "1px solid var(--border)",
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        navigate(
                                            `/store/${store.siteId}?tab=findings&category=${zone.category}`
                                        )
                                    }
                                >
                                    <div
                                        style={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: "var(--text-muted)",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em",
                                        }}
                                    >
                                        {zone.code}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 14,
                                            color: "var(--text-primary)",
                                            marginTop: 4,
                                        }}
                                    >
                                        {zone.label}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "var(--text-secondary)",
                                            marginTop: 8,
                                        }}
                                    >
                                        Planogram PDF not uploaded
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            )}

            <div className="card" style={{ marginTop: 24, padding: 24 }}>
                <div className="card-title">Planogram Management</div>
                <p style={{ color: "var(--text-secondary)", fontSize: 14, lineHeight: 1.6 }}>
                    Marketing team uploads planogram PDFs per zone per site. The AI engine
                    uses these as the reference standard when scoring compliance. Zone images
                    are extracted automatically and matched to camera positions during
                    calibration.
                </p>
                <p style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 12 }}>
                    Upload functionality coming in Phase 3 â€” planogram PDFs are currently
                    stored in F:\Planogram\ on the scan server.
                </p>
            </div>
        </div>
    );
}

export default Planograms;

